<template>
  <component :is="caseComponent"></component>
</template>

<script>
// ===== 案例注册表：id -> 组件名 =====
// 新增案例只需两步：① 在 components 里加一行懒加载；② 在 CASE_MAP 里加一条映射。
const CASE_MAP = {
  1: 'CaseRemoteDesk',   // FOCUS - 智能制造全栈式融合管控平台
  2: 'CaseVoicePrint',   // AI声纹与视觉融合智能检测系统
  // 3: 'CaseXxx',
};

// 兜底案例（id 未匹配时展示）
const FALLBACK_ID = 1;

export default {
  name: 'CustomerCaseDetail',
  // 懒加载：访问哪个案例才加载哪个，案例增多不影响首屏体积
  components: {
    CaseRemoteDesk: () => import('./CaseRemoteDesk.vue'),
    CaseVoicePrint: () => import('./CaseVoicePrint.vue'),
  },
  computed: {
    caseComponent() {
      const id = Number(this.$route.query.id) || FALLBACK_ID;
      return CASE_MAP[id] || CASE_MAP[FALLBACK_ID];
    }
  },
};
</script>
